<nz-card class="rectangle">
    <div class="col-10">
      <label class="title">Üye Girişi</label>
    </div>
    <form class="form-style">
      <div class="col-md-12">
        <mat-form-field class="input-style">
          <mat-label>Telefon numaranızı girin</mat-label>
          <input matInput>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field class="input-style">
          <mat-label>Lütfen Paycell şifrenizi giriniz</mat-label>
          <input matInput>
          <mat-hint>Paycell uygulamasına giriş yaparken kullandığınız şifrenizi girin</mat-hint>
        </mat-form-field>
      </div>
    </form>
    <div class="col-md-12 d-flex flex-style">
      <div class="col-md-5 password-title">
        <label class="forgot-password" (click)="forgotPassword()">Şifremi unuttum</label>
      </div>
      <div class="col-md-7 login-div px-0">
        <button type="button" class="login-button" (click)="otpPage()"><span class="login-text">Giriş Yap</span></button>
      </div>
    </div>
    <div class="path"></div>
    <div class="password-title"><label class="footer-desc">Paycell'in yok mu? <span
      class="footer-desc-text" (click)="signupRouting()">Hemen Üye ol.</span></label>
    </div>
  </nz-card>
